import styled from "styled-components";

export const PageContainer = styled.div`
  min-height: 100vh;
  padding: 2rem 0;
`;

export const PageHeader = styled.div`
  margin-bottom: 2rem;

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;

    h1 {
      color: #203b34;
      font-size: 2rem;
      font-weight: 600;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 0.75rem;
    }
  }

  .subtitle {
    color: #6c757d;
    font-size: 0.95rem;
    margin-top: 0.5rem;
  }

  @media (max-width: 768px) {
    .header-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }
  }
`;

export const NewButton = styled.button`
  background: #f9ae17;
  color: #203b34;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 4px rgba(249, 174, 23, 0.3);

  &:hover {
    background: #e09d0f;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(249, 174, 23, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  .icon {
    font-size: 1.1rem;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 90%;
  margin: 0 auto;
  padding: 0 1rem;
`;

export const FilterSection = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 1.5rem;
  margin-bottom: 2rem;
`;

export const ListSection = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  padding: 2rem;
`;
